/*
 * @Author: Teemo Ding
 * @Date: 2022-04-15 16:53:43
 * @LastEditTime: 2022-05-05 11:26:40
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/analytics/report.ts
 */
import { get, post } from 'src/tools/server';

export const reportList = (startIndex, pageCount, data) => {
  return post<any>(`/portal/report/list/${startIndex}/${pageCount}`, data, {});
};

export const reportDetailEdit = (startIndex, pageCount, data) => {
  return post<any>(`/portal/report/view/${startIndex}/${pageCount}`, data, {});
};

export const reportDetailInit = (startIndex, pageCount, reportCategory) => {
  return get<any>(
    `/portal/report/view/${reportCategory}/${startIndex}/${pageCount}`,
    {},
  );
};

export const getDateRange = (dateRange) => {
  return get<any>(`/portal/report/dateRange/${dateRange}`, {});
};

export const saveReport = (data) => {
  return post<any>(`/portal/report/save`, data, {});
};

export const exportReport = (data) => {
  return post<any>(`/portal/report/export`, data, {
    returnWholeData: true,
    responseType: 'arraybuffer',
  });
};

export const getReportDetail = (reportUuid) => {
  return get<any>(`/portal/report/view/${reportUuid}`, {});
};

export const deleteReport = (data) => {
  return post<any>(`/portal/report/delete`, data, {});
};

export const searchReport = (data) => {
  return post<any>(`/portal/report/search`, data, {});
};
